import { render, staticRenderFns } from "./CouponExpiration.vue?vue&type=template&id=8a22ed38&"
import script from "./CouponExpiration.vue?vue&type=script&lang=js&"
export * from "./CouponExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports